import React from "react";

import { Heading, Page, Text } from "../theme";
export const ThankYou = props => {
  return (
    <Page>
      <Heading width={1} color="primary" fontSize={90}>
        Thank You
      </Heading>
      <Text width={1} fontSize={3} color="gray">
        We will get back to you shortly.
      </Text>
    </Page>
  );
};
